import { getCsSubPackageData, getPrebuiltPackageData } from './cs-subscription-api';
import { trackingPayload } from './cs-subscription-tracking';
import { number_format, tracking, sendChameleonAndHeapTrackEvent } from '@bark/bark-core';
import CsSubscriptionCustomPackage from './cs-subscription-custom-package';
import CsSubscriptionPayment from './cs-subscription-payment';

export const csSubscriptionPayment = CsSubscriptionPayment();
export const csSubscriptionCustomPackage =
	CsSubscriptionCustomPackage(csSubscriptionPayment);

export function validPackages(packages) {
	for (const csPackage of packages) {
		if (
			csPackage?.credits == 0 ||
			csPackage?.purchased_leads == 0 ||
			csPackage?.price_per_month_in_pence < 100
		) {
			return false;
		}
	}
	return true;
}

export function bindSelectPackageCtaListeners() {
	$('#js-select-package-silver')
		.off('click.select-package-silver')
		.on('click.select-package-silver', async function () {
			trackSelectPackage('silver');
			csSubscriptionPayment.processPaymentForPackage('silver');
		});

	$('#js-select-package-gold')
		.off('click.select-package-gold')
		.on('click.select-package-gold', async function () {
			trackSelectPackage('gold');
			csSubscriptionPayment.processPaymentForPackage('gold');
		});

	$('#js-select-package-custom')
		.off('click.select-package-custom')
		.on('click.select-package-custom', async function (e) {
			if (!e.target.matches('[disabled]')) {
				trackSelectPackage('custom');
				csSubscriptionPayment.processPaymentForPackage('custom');
			}
		});
}

export function bindSelectPrebuiltPackageCtaListener() {
	$('#js-select-package-prebuilt')
		.off('click.select-package-prebuilt')
		.on('click.select-package-prebuilt', async function () {
			trackSelectPackage('prebuilt');
			csSubscriptionPayment.processPaymentForPackage('prebuilt');
		});
}

export function bindPaymentFrequencyToggleListeners() {
	$('#payment-frequency-toggle .option')
		.off('click')
		.on('click', function () {
			const selectedOption = $(this).data('optionValue');
			if (selectedOption !== csSubscriptionPayment.getSelectedPaymentFrequency()) {
				csSubscriptionPayment.updateSelectedPaymentFrequency(selectedOption);

				$('#payment-frequency-toggle').find('.option').removeClass('active');
				$(`#payment-frequency-toggle [data-option-value=${selectedOption}]`).addClass(
					'active',
				);
				$('.package-card')
					.find('.js-show-for-month, .js-show-for-week')
					.addClass('d-none');
				$('.package-card').find(`.js-show-for-${selectedOption}`).removeClass('d-none');

				tracking('credit-subscription-self-service-page', 'change_payment_frequency', {
					...trackingPayload,
					payment_frequency: selectedOption,
				});

				if (selectedOption === 'month') {
					$('#custom-pack-n-leads').attr('min', '10').attr('max', '250');
					$('#custom-pack-n-leads').val($('#custom-pack-n-leads-month').val());
					csSubscriptionCustomPackage.refreshCustomPackData();
				}

				if (selectedOption === 'week') {
					$('#custom-pack-n-leads').attr('min', '2').attr('max', '57');
					$('#custom-pack-n-leads').val($('#custom-pack-n-leads-week').val());
					csSubscriptionCustomPackage.refreshCustomPackData();
				}
			}
		});
}

export function trackSelectPackage(packageName) {
	tracking('credit-subscription-self-service-page', 'select_package', {
		...trackingPayload,
		package_name: packageName,
	});
	sendChameleonAndHeapTrackEvent(
		'Credit subscription self service page package selected',
		{ package_name: packageName },
	);
}

export function showSelectPackageLoading(packageName) {
	$(`#js-loading-package-link-${packageName}`).removeClass('d-none');
}

export function disableSelectPackages() {
	$('#js-select-package-gold').addClass('disabled');
	$('#js-select-package-gold').attr('disabled', true);
	$('#js-select-package-silver').addClass('disabled');
	$('#js-select-package-silver').attr('disabled', true);
}

export async function buildCsSubPackages() {
	const { Handlebars } = window;
	const $packagesSection = $('#cs-packages');
	const $packagesAvailableSection = $('#packages-available');
	const $packagesUnAvailableSection = $('#packages-unavailable');
	const $packagesContainer = $('#packages-container');
	const usageCardTemplate = Handlebars.compile(
		document.getElementById('usage-card-template').innerHTML,
	);
	const packageCardTemplate = Handlebars.compile(
		document.getElementById('package-card-template').innerHTML,
	);

	$packagesContainer.empty();

	const response = await getCsSubPackageData();

	//Check to show packages or not
	if (
		!response?.data ||
		(typeof response.data == 'array' && !response.data.length) ||
		!response.data?.usage ||
		!response.data?.packages ||
		!response.data.packages.length ||
		response.data.usage?.days_of_spend < 30 ||
		!validPackages(response.data.packages)
	) {
		$packagesAvailableSection.addClass('d-none');
		$packagesUnAvailableSection.removeClass('d-none');
		$packagesSection.removeClass('d-none');
		return;
	}

	const usageCardHtml = usageCardTemplate({
		creditsSpent: response.data.usage?.credits_spent_in_30_days,
		leads: response.data.usage?.purchased_leads,
		avgMonthlySpend: number_format(
			response.data?.usage?.avg_monthly_spend_in_pence / 100,
			2,
		),
		pricePerCredit: number_format(
			response.data.usage?.price_per_credit_in_pence / 100,
			2,
		),
		currencySymbol: response.data.usage?.currency_symbol,
	});
	$packagesContainer.append(usageCardHtml);

	const packages = response.data.packages;

	const recommendedPackage = packages.find(({ name }) => name === 'silver');

	const recommendedPackageHtml = packageCardTemplate({
		showNLeads: true,
		name: recommendedPackage?.name,
		displayName: 'Recommended',
		creditsPerMonth: recommendedPackage?.credits_per_month,
		creditsPerWeek: recommendedPackage?.credits_per_week,
		leadsPerMonth: recommendedPackage?.purchased_leads_per_month,
		leadsPerWeek: recommendedPackage?.purchased_leads_per_week,
		pricePerMonth: number_format(recommendedPackage?.price_per_month_in_pence / 100, 2),
		pricePerWeek: number_format(recommendedPackage?.price_per_week_in_pence / 100, 2),
		pricePerCredit: number_format(recommendedPackage?.price_per_credit_in_pence / 100, 2),
		discountPercentage: recommendedPackage?.discount_percentage,
		currencySymbol: response.data.usage?.currency_symbol,
	});

	$packagesContainer.append(recommendedPackageHtml);

	const customPackageHtml = packageCardTemplate({
		showNLeads: true,
		isCustom: true,
		name: 'custom',
		displayName: 'Custom',
		creditsPerMonth: '---',
		creditsPerWeek: '---',
		leadsPerMonth: '---',
		leadsPerWeek: '---',
		pricePerMonth: '---',
		pricePerWeek: '---',
		pricePerCredit: '---',
		currencySymbol: response.data.usage?.currency_symbol,
	});

	$packagesContainer.append(customPackageHtml);

	$packagesUnAvailableSection.addClass('d-none');
	$packagesAvailableSection.removeClass('d-none');
	$packagesSection.removeClass('d-none');

	await csSubscriptionPayment.init(packages, response.data.usage?.currency_symbol);
	bindSelectPackageCtaListeners();

	csSubscriptionCustomPackage.bindCustomPackListeners();
	await csSubscriptionCustomPackage.refreshCustomPackData();

	bindPaymentFrequencyToggleListeners();

	return;
}

export async function showCsSubPrebuiltPackage(uuid) {
	const { Handlebars } = window;
	const $packagesSection = $('#cs-packages');
	const $packagesAvailableSection = $('#packages-available');
	const $packagesUnAvailableSection = $('#packages-unavailable');
	const $packagesContainer = $('#packages-container');

	const packageCardTemplate = Handlebars.compile(
		document.getElementById('package-card-template').innerHTML,
	);

	$packagesContainer.empty();

	const response = await getPrebuiltPackageData(false, uuid);

	if (!response?.data) {
		$packagesAvailableSection.addClass('d-none');
		$packagesUnAvailableSection.removeClass('d-none');
		$packagesSection.removeClass('d-none');
		return;
	}

	const prebuiltPackageData = response.data;

	const prebuiltPackageHtml = packageCardTemplate({
		name: 'prebuilt',
		displayName: 'Custom package',
		creditsPerMonth: prebuiltPackageData?.number_of_credits,
		creditsPerWeek: prebuiltPackageData?.number_of_credits,
		pricePerMonth: number_format(prebuiltPackageData?.subtotal_in_pence / 100, 2),
		pricePerWeek: number_format(prebuiltPackageData?.subtotal_in_pence / 100, 2),
		currencySymbol: prebuiltPackageData?.currency_symbol,
	});

	$packagesContainer.append(prebuiltPackageHtml);

	$packagesUnAvailableSection.addClass('d-none');
	$packagesAvailableSection.removeClass('d-none');
	$packagesSection.removeClass('d-none');

	const packages = [
		{
			name: 'prebuilt',
			credits_per_month: prebuiltPackageData?.number_of_credits,
			credits_per_week: prebuiltPackageData?.number_of_credits,
			price_per_month_in_pence: prebuiltPackageData?.subtotal_in_pence,
			price_per_week_in_pence: prebuiltPackageData?.subtotal_in_pence,
			uuid: prebuiltPackageData?.uuid,
		},
	];

	await csSubscriptionPayment.init(packages, prebuiltPackageData?.currency_symbol);
	csSubscriptionPayment.updateSelectedPaymentFrequency(
		prebuiltPackageData?.billing_interval,
	);
	$('.package-card').find('.js-show-for-month, .js-show-for-week').addClass('d-none');
	$('.package-card')
		.find(`.js-show-for-${prebuiltPackageData?.billing_interval}`)
		.removeClass('d-none');
	$('#packages-available-heading, #payment-frequency-section')
		.removeClass('d-flex')
		.addClass('d-none');
	bindSelectPrebuiltPackageCtaListener();

	return;
}
